/** "Jane Q. Doe" -> "JD"; one word -> its first letter; nothing -> "?". For the avatar circle only. */
export function initials(name: string | null): string {
  const words = (name ?? '').split(/\s+/).filter((w) => w !== '')
  const first = words[0]
  const last = words[words.length - 1]
  if (!first || !last) return '?'
  if (words.length === 1) return first.charAt(0).toUpperCase()
  return (first.charAt(0) + last.charAt(0)).toUpperCase()
}
